// 定义全局函数位置
import moment from 'moment'
import Vue from 'vue'

// export default {
//   install (Vue) {
//     Vue.prototype.timestampToMoment = (timestamp) => {
//       if (timestamp !== '') {
//         if (timestamp.toString().length < 13) {
//           timestamp = timestamp * 1000
//         }
//         return moment(timestamp)
//       } else {
//         return moment()
//       }
//     }
//   }
// }
Vue.prototype.timestampToMoment = function (timestamp) {
  if (timestamp !== '') {
    if (timestamp.toString().length < 13) {
      timestamp = timestamp * 1000
    }
    return moment(timestamp)
  } else {
    return moment()
  }
}

Vue.prototype.inArray = function (stringToSearch, arrayToSearch) {
  for (var s = 0; s < arrayToSearch.length; s++) {
    var thisEntry = arrayToSearch[s].toString()
    if (thisEntry === stringToSearch) {
      return true
    }
  }
  return false
}
